import type { CommsUnreadNotification } from '@interfaces/INotificationsApi';
import type { INotificationItem } from '@interfaces/INotificationItem';
import { CommsUnreadVisual } from './CommsUnreadVisual/CommsUnreadVisual';

/** How a chat notification reads, and the name it goes by once that is known. */
export interface ICommsUnreadWording {
  text: string;
  name?: string; // The channel's name, or the other person's in a direct message
}

/**
 * Chat's item: a `comms.unread` notification drawn for the menu. The caller
 * words it — it knows the language and the people's names — and the item opens
 * the conversation in the site's Comms hub.
 */
export function commsUnreadItem(
  siteId: string,
  notification: CommsUnreadNotification,
  { text, name }: ICommsUnreadWording,
): INotificationItem {
  const { id: conversationId, kind } = notification.conversation;

  return {
    id: notification.id,
    visual: <CommsUnreadVisual name={name} isChannel={kind === 'channel'} />,
    text,
    at: notification.at,
    to: `/comms/${encodeURIComponent(siteId)}?channel=${encodeURIComponent(conversationId)}`,
  };
}
